import { FC, memo } from "react";

import { OrderStatus } from "@/apis/clients";
import { orderStatusToString } from "@/libs/enums/enumStrings";

interface Props {
  statusVal: OrderStatus;
  className?: string;
  divClassName?: string;
}

/**
 * 色指定
 */
function colorToClasses(s?: OrderStatus) {
  switch (s) {
    case OrderStatus.UNPAID:
      return "bg-[#FFDEE0] text-color-red_error";
    case OrderStatus.BILLED: // 請求済 黒背景白文字
      return "bg-[#45BEAB]/[0.2] border-0 text-[#07917B]";
    case OrderStatus.PAID:
      return "bg-primary-hover text-primary-dark";
    // FINISHED (7) not yet in swagger enum spec — keep as cast
    case 7 as any:
    case OrderStatus.FREE_FINISHED:
      return "bg-primary-hover text-primary-dark border-0";
    case OrderStatus.COMPLETION:
    case OrderStatus.CANCEL:
      return "bg-gray-200 text-[#787878]";
    case OrderStatus.WAITINGCANCEL:
      return "bg-[#F0B020]/20 text-[#E09B00]";
    case OrderStatus.TRIALING:
      return "bg-blue-100 text-blue-700";
    default:
      return "bg-primary-hover text-primary-dark";
  }
}

const ReservationOrderStatusBadgeBase: FC<Props> = ({
  className,
  statusVal,
  divClassName
}) => {
  const classNames = [
    "flex pt-0.5 items-center justify-center font-bold text-center min-h-[1.5rem] w-[100px] rounded-3xl text-xs",
    colorToClasses(statusVal),
    className,
  ].join(" ");

  return (
    <div className={divClassName}>
      <span className={classNames}>{orderStatusToString(statusVal)}</span>
    </div>
  );
};

export const ReservationOrderStatusBadge = memo(
  ReservationOrderStatusBadgeBase,
);
